import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  const isCustomerListPage = pathname === "/customer-insights/list";

  useEffect(() => {
    if (!isCustomerListPage) window.scrollTo(0, 0);

    // eslint-disable-next-line
  }, [pathname]);

  return null;
}
